<template>
  <div class="loading">
     <img src="http://images.xdf.cn/cms20150819/img/load_h.gif" alt="加载中...">
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="stylus" scoped>
.loading
  height: 100%
  margin: 0 auto
  img
    height: 100%
    width: 100%
</style>



// WEBPACK FOOTER //
// src/common-components/Loading.vue